<template>
  <div class="assets-trend-graph-wrapper">
    <div class="filter-items clearfix">
      <ul class="float-right">
        <li v-for="filterItem in filterItems" v-bind:key="filterItem.id">
          <button
            type="button"
            class="btn btn-link"
            :class="{ active: filterItem.id === filter }"
            @click="selectFilter(filterItem.id)"
          >
            {{ filterItem.name }}
          </button>
        </li>
        <!--        <li>-->
        <!--          <button-->
        <!--            type="button"-->
        <!--            class="btn btn-link"-->
        <!--            :class="{ active: filter === 'custom' }"-->
        <!--            @click="openCustomDatePicker()"-->
        <!--          >-->
        <!--            Vlastné-->
        <!--          </button>-->
        <!--        </li>-->
      </ul>
    </div>
    <AssetsDatePicker
      v-if="showCustomDatePicker"
      :onSelect="selectCustomFilter"
      :fromDate="from"
      :toDate="to"
    />
    <div class="chart-wrapper">
      <Loading v-if="loading" class="h-100 p-5" />
      <vue-chart v-else type="line" :data="chartData" :options="options" />
    </div>
  </div>
</template>

<script>
import VueChart from "vue-chart-js";
import Loading from "./Loading";
import { TimeFilter } from "../types";
import chartOptions from "./assetsTrendGraphOptions";
import AssetsDatePicker from "./AssetsDatePicker";

export default {
  name: "AssetsTrendGraph",
  components: {
    Loading,
    VueChart,
    AssetsDatePicker
  },
  methods: {
    loadData() {
      // if (this.currentPortfolio) {
      //   this.chartData.datasets[1] = this.pl;
      // } else {
      //   if (this.chartData.datasets[1]) {
      //     this.chartData.datasets[1] = null;
      //   }
      // }

      this.$store.dispatch("assets/loadAssetsHistory", {
        investmentStrategyId: this.currentPortfolio
      });
    },
    selectCustomFilter(from, to) {
      this.$store.commit("assets/setCustomFilter", { from, to });
      this.loadData();
      this.showCustomDatePicker = false;
    },
    selectFilter(filterId) {
      this.$store.commit("assets/selectFilter", filterId);
      this.loadData();
      this.showCustomDatePicker = false;
    },
    initGraph() {
      this.showCustomDatePicker = false;
      const { labels, datasets } = this.report;
      this.chartData.labels = labels;
      if (this.currentPortfolio) {
        this.chartData.datasets = [this.assetsDataset, this.plDataset];
        this.chartData.datasets[0].data = datasets[0];
        this.chartData.datasets[1].data = datasets[1];
      } else {
        this.chartData.datasets = [this.assetsDataset];
        this.chartData.datasets[0].data = datasets[0];
      }
    },
    openCustomDatePicker() {
      this.showCustomDatePicker = true;
      this.$store.commit("assets/selectFilter", "custom");
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    currentPortfolio() {
      this.loadData();
    },
    report: {
      deep: true,
      handler() {
        this.initGraph();
      }
    }
  },
  computed: {
    loading() {
      return this.$store.state.assets.loading;
    },
    filter() {
      return this.$store.state.assets.filterId;
    },
    report() {
      return this.$store.state.assets.assetsGraphData;
    },
    options: () => chartOptions,
    currentPortfolio() {
      return this.$store.state.portfolio.selected;
    },
    from: {
      get: function() {
        return this.$store.state.assets.from;
      },
      set: function(newValue) {
        this.$store.state.assets.from = newValue;
      }
    },
    to: {
      get: function() {
        return this.$store.state.assets.to;
      },
      set: function(newValue) {
        this.$store.state.assets.to = newValue;
      }
    }
  },
  data() {
    return {
      showCustomDatePicker: this.filterId === TimeFilter.CUSTOM,
      filterItems: [
        {
          id: TimeFilter.WEEK,
          name: this.$tc("x_days", 2, { x: 7 })
        },
        {
          id: TimeFilter.WEEKS_2,
          name: this.$tc("x_days", 2, { x: 14 })
        },
        {
          id: TimeFilter.MONTH,
          name: this.$tc("x_months", 0, { x: 1 })
        },
        {
          id: TimeFilter.MONTHS_3,
          name: this.$tc("x_months", 1, { x: 3 })
        },
        {
          id: TimeFilter.YEAR,
          name: this.$tc("x_years", 0, { x: 1 })
        }
      ],
      chartData: {
        labels: [],
        datasets: []
      },
      assetsDataset: {
        backgroundColor: this.getGraphsCssVariables('__graph-color-2'),
        borderWidth: 0,
        data: [],
        pointStyle: "circle",
        pointBorderWidth: 0,
        pointBorderColor: "#fff",
        pointBackgroundColor: this.getGraphsCssVariables('__graph-color-2'),
        pointRadius: 0,
        pointHoverRadius: 6,
        pointHoverBorderWidth: 2,
        showLine: true,
        label: this.$t("assets"),
        yAxisID: "left-y-axis"
      },
      plDataset: {
        borderColor: this.getGraphsCssVariables('__graph-line-color'),
        borderWidth: 2,
        data: [],
        pointStyle: "circle",
        pointBorderWidth: 0,
        pointBorderColor: "#fff",
        pointBackgroundColor: this.getGraphsCssVariables('__graph-line-color'),
        pointRadius: 0,
        pointHoverRadius: 6,
        pointHoverBorderWidth: 2,
        showLine: true,
        label: "P/L",
        yAxisID: "right-y-axis"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.assets-trend-graph-wrapper {
  .chart-wrapper {
    height: 350px;
    margin-top: 30px;
  }

  .filter-items {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: inline-block;

        .btn-link {
          color: $grey-text;
          outline: none;
          box-shadow: none;
          text-transform: uppercase;
          font-size: 13px;
          text-decoration: none !important;

          &:hover,
          &.active {
	          color: lighten($grey-text, 30%);
          }
        }
      }
    }
  }
}
</style>
